import {Injectable, Injector} from '@angular/core';
import {lastValueFrom,Observable, of} from 'rxjs';
import {DialogType, FSInvoiceDialogService} from './fsinvoice.dialog.service';
import {LoggingService} from 'mclane-apptemplate-lib';
import {Router} from '@angular/router';
import {SplunkMessage} from '@model/splunkMessage';
import {GlobalErrorHandlerService} from '~/app/core/services/globalErrorHandlerService';
import { LoadingIndicatorHelper } from './loading-indicator-helper';


@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  public splunkMsg: SplunkMessage = new SplunkMessage();
  constructor(private fsinvoiceDialogService: FSInvoiceDialogService,
              public console: LoggingService,
              public injector: Injector,
              public globalErrorHandlerService: GlobalErrorHandlerService,
              public loadingIndicator: LoadingIndicatorHelper) {
  }

  handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error !== null && error !== undefined) {
        console.warn('OLI.API.SplunkMsg ->');
        console.error(error.message);

        console.warn('OLI.API.SplunkOperation ->');
        console.error(operation);

        console.error(error);
      }
      const message = error.error ? error.error : this.sanitizeMessage(error.message);
   
      this.console.error('Error: ' + message + ' Unable to retrieve info from API.');
      this.console.error('operation: ' + operation + ' Unable to retrieve info from API.');

      let splunkId = Date.now().toString(36).toUpperCase() + '.' + Math.random().toString(36).substring(2, 8).toUpperCase();

      const router = this.injector.get(Router);
      const display = ' SPL.ID: ' + splunkId;
      const log = 'SPLID.UI.OLI.API: ' + splunkId;

      this.splunkMsg.splid = log + ' page=' + router.url;
      this.splunkMsg.message = 'OLI.API.SplunkMsg: ' + message + ' - OLI API ERROR - ' + ' - OLI.API.SplunkOperation: ' + operation;

      console.log(this.splunkMsg);

      lastValueFrom(this.globalErrorHandlerService.generateSplunkId(this.splunkMsg))
        .then(r => console.log(r))
        .catch(e => console.log(e));

      if (this.fsinvoiceDialogService !== undefined) {
        this.fsinvoiceDialogService.openDialog(
          {
            type: DialogType.ERROR,
            title: 'API Error!',
            content: this.getErrorMessage(error.status, operation) + ' ' + '\n' + display,
            actions: [
              {text: 'Ok', primary: true}
            ],
            width: 400
          }).then(r => r);
      } else {
        alert('An unexpected api error occurred. Please contact McLane Helpdesk.' + '\n' + display);
      }

      if (this.loadingIndicator.isLoading) {
        this.loadingIndicator.hide();
      }
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  public sanitizeMessage(message: string): string {
    if (message) {
      var httpIdx = message.indexOf('http');
      var restIdx = message.indexOf('/rest/');
      if (httpIdx > -1 && restIdx > -1) {
        message = message.substring(0, httpIdx) + ' ' + message.substring(restIdx + 6).replace(/\//g, ' ');
      }
    }
    return message;
  }

  // Get error message for dialog based on error code
  public getErrorMessage(errorCode: number, operation: string): string {
    const customKey = `${errorCode}_${operation}`;
    return this.customMessages[customKey] || this.errorMessages[errorCode] || 'An unexpected error occurred. Please contact McLane Helpdesk.';
  }

  errorMessages: { [key: number]: string } = {
    404: 'Resource not found. Please try again after sometime or contact McLane Helpdesk.',
    401: 'Unauthorized access. Please login and try again.',
    403: 'Forbidden access. You do not have permission to view this resource.',
    400: 'Bad request. Please check the request parameters and try again.',
    500: 'Something went wrong on our end. Please try again later or contact McLane Helpdesk.',
    502: 'We are experiencing some issues. Please try again later.',
    503: 'Service unavailable. The server is currently unable to handle the request. Please try again later.',
    504: 'The request took too long to process. Please try reducing the data requested or try again later.'
  }

  private customMessages: { [key: string]: string } = {
    '406_StatementsService getStoreSummary': 'Stores data not found. Please check the store details.'
  };

}
